// extracted by mini-css-extract-plugin
export default {"zoomModal":"x4-z"};